import {Injectable} from '@angular/core';
import {iGenre} from '@app/interfaces/IGenre';


@Injectable({
  providedIn: 'root'
})
export class CLPService {
  public genres: Array<iGenre> = null;
  private _isBackFromItem: boolean = false;
  public get isBackFromItem(): boolean {
    return this._isBackFromItem;
  }

  public set isBackFromItem(v: boolean) {
    this._isBackFromItem = v;
  }


  private _selectTab: { identifier: number, indexTab: number };
  public get selectTab(): { identifier: number, indexTab: number } {
    return this._selectTab;
  }

  public set selectTab(v: { identifier: number, indexTab: number }) {
    this._selectTab = v;
  }


  constructor() {
  }

  public setGenres(items: Array<iGenre>) {
    this.genres = items;
  }

  public getSubgenres(id: string): Array<iGenre> {
    return this.genres.find(c => c.genreId === id).subGenres;
  }

  public hasItem(id): boolean {
    if (this.genres && this.genres.length > 0)
      return this.genres.some(c => c.genreId === id);
    return false;
  }
}
